//src/api/examApi.js

import axiosInstance from './axiosInstance'; 

export const fetchExamTypes = async () => {
  const response = await axiosInstance.get('/exam-types/');
  return response.data;
};

export const createExam = async (examData) => {
  const response = await axiosInstance.post('/exams/create', examData);
  return response.data;
};

export const fetchExams = async () => {
  const response = await axiosInstance.get('/exams/');
  return response.data;
};

export const updateExam = async (examData) => {
  // console.log('Updating exam with data:', examData);
  // console.log('URL:', `/exams/update/${examData.examId}`);
  try {
    const response = await axiosInstance.post(`/exams/update`, examData);
    // console.log('Response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error updating exam:', error.response || error);
    throw error;
  }
};

export const deleteExam = async (examId) => {
  try {
    const response = await axiosInstance.post('/exams/delete', null, {
      params: {
        id: examId
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting exam:', error);
    throw error; 
  }
};

export const fetchExamsDashboard = async (params) => {
  try {
    const response = await axiosInstance.post('/exams/dashboard', params);
    return response.data;
  } catch (error) {
    console.error('Error fetching exams dashboard:', error);
    throw error;
  }
};


export const fetchExamById = async (id) => {
  try {
    const response = await axiosInstance.get(`/exams/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching exam data:', error);
    throw error;
  }
};